/* 🤖 this file was generated by svg-to-ts */
export const iconAdd: {
    name: 'add';
    data: string;
} = {
    name: 'add',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><path fill="#000" fill-rule="evenodd" d="M9.06.075c.349 0 .638.26.684.597l.006.094-.001 7.602h7.604a.69.69 0 0 1 .094 1.376l-.094.006H9.75v7.603a.69.69 0 0 1-1.374.094l-.006-.094-.001-7.603H.766a.69.69 0 0 1-.094-1.375l.094-.006 7.602-.001V.766c0-.382.31-.691.691-.691"/></svg>`
};
